const IconExpand = (props) => {
  return (
    <svg
      width="17"
      height="18"
      viewBox="0 0 17 18"
      fill={props.fill}
      stroke={props.stroke}
      className={props.className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.1665 6.50001L16.1665 1.50001M16.1665 1.50001H11.1665M16.1665 1.50001L8.6665 9M6.99984 1.5H5.1665C3.76637 1.5 3.06631 1.5 2.53153 1.77248C2.06112 2.01217 1.67867 2.39462 1.43899 2.86502C1.1665 3.3998 1.1665 4.09987 1.1665 5.5V12.5C1.1665 13.9001 1.1665 14.6002 1.43899 15.135C1.67867 15.6054 2.06112 15.9878 2.53153 16.2275C3.06631 16.5 3.76637 16.5 5.1665 16.5H12.1665C13.5666 16.5 14.2667 16.5 14.8015 16.2275C15.2719 15.9878 15.6543 15.6054 15.894 15.135C16.1665 14.6002 16.1665 13.9001 16.1665 12.5V10.6667"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default IconExpand
